import HundDto from "./HundDto";

export default class FormIhrTierDto {
    anzahlHunde?: number;

    hunde: HundDto[] = [];

    hundeVersicherbarBest?: boolean;

}